class BxfRadioConstants {
    static STRING = {
        CONTAINER: 'bxf-radio__container',
        CONTAINER_CARD_HEADER: 'bxf-radio__container--card-header',
        RADIO: 'bxf-radio',
        RADIO_ICON: 'bxf-radio__icon',
        DISABLED: 'bxf-radio__disabled',
        READONLY: 'bxf-radio__readonly',
        BXF_RADIO_VALIDATION_ERROR: 'bxf-radio__validation-error',
        BXF_RADIO_VALIDATION_WARNING: 'bxf-radio__validation-warning',
        LABEL: 'bxf-radio__label-container',
        LABEL_RIGHT: 'bxf-radio__label-container--right',
        LABEL_SPAN: 'bxf-radio__label-span',
        LABEL_DISABLED: 'disabled',
        LABEL_READONLY: 'bxf-radio__label--readonly',
        SECONDARY_LABEL: 'bxf-radio__secondary-label',
        SECONDARY_LABEL_GROUP: 'bxf-radio-group__secondary-label',
        SECONDARY_LABEL_RIGHT: 'bxf-radio__secondary-label--right',
    };
}

export { BxfRadioConstants as B };
